/**
 * Module to handle application strings localization.
 *
 * @module assets.lang
 * @see vue-i18n
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import Project from '@/constants';
// import * as fr from './fr';
import * as en from './en';

/*
 * Register vue-i18n to all Vue instances, and set the locale to the global
 * local configured in the project constants file.
 */
Vue.use(VueI18n);

/**
 * Object of languages packs.
 *
 * @constant
 * @private
 */
const languages = {
  en,
};

/**
 * Object of i18n locale strings mapped to their string key/val objects.
 *
 * @constant
 * @private
 */
const languagesStrings = {};

/**
 * Object of i18n locale strings mapped to the name of the language
 * in their own locale.
 *
 * @constant
 * @export
 */
export const availableLanguages = {};

Object.keys(languages).forEach((l) => {
  languagesStrings[l] = languages[l].messages;
  availableLanguages[l] = languages[l].name;
});

/**
 * VueI18n instance containing the default locale and the available
 * translation language packs.
 *
 * @constant
 * @private
 */
const i18n = new VueI18n({
  locale: Project.defaultLocale,
  fallbackLocale: Project.defaultLocale,
  messages: languagesStrings,
});

/**
 * Export the available vue i18n object.
 *
 * @exports
 */
export default i18n;



// WEBPACK FOOTER //
// ./src/assets/lang/index.js